import { render, staticRenderFns } from "./CreateTemplateFolderModal.vue?vue&type=template&id=5f050eda&scoped=true"
import script from "./CreateTemplateFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateTemplateFolderModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateFolderModal.vue?vue&type=style&index=0&id=5f050eda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f050eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f050eda')) {
      api.createRecord('5f050eda', component.options)
    } else {
      api.reload('5f050eda', component.options)
    }
    module.hot.accept("./CreateTemplateFolderModal.vue?vue&type=template&id=5f050eda&scoped=true", function () {
      api.rerender('5f050eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/CreateTemplateFolderModal.vue"
export default component.exports